import {
    LOAD_GUEST_LIST,
    ADD_GUEST_IN_LIST,
    DELETE_GUEST,
    EDIT_GUEST,
    GET_GUEST_BY_BOOKING,
    CLEAR_GUEST,
} from './types';
import API from '../../config/api-url';
import { BACKEND_API } from '../../config/middleware';

export const addGuests = (data) => ({
  type: BACKEND_API,
  payload: Object.assign({
    type: ADD_GUEST_IN_LIST,
    method: 'post',
    url: API.GUEST,
    data,
  }),
});

export const loadGuests = () => ({
  type: BACKEND_API,
  payload: Object.assign({
    type: LOAD_GUEST_LIST,
    method: 'get',
    url: API.GUEST,
  }),
});

// TODO: Delete this - Create the getGuestByBooking - booking.guestId/bookerId in the components using data stored in Redux.
export const getGuestByBooking = (id)=>({
  type:BACKEND_API,
  payload: Object.assign(
      {
        type:GET_GUEST_BY_BOOKING,
        method:'get',
        url:`${API.GET_GUEST_BY_BOOKING}/${id}`,
      },
  )
})

export const deleteGuest = (id) => ({
  type: BACKEND_API,
  payload: Object.assign({
    type: DELETE_GUEST,
    method: 'delete',
    url: `${API.GUEST}${id}`,
  }),
});

export const editGuest = (data) => ({
  type: BACKEND_API,
  payload: Object.assign({
    type: EDIT_GUEST,
    method: 'put',
    url: API.GUEST,
    data,
  }),
});

export const clearGuest=()=>({
    type: CLEAR_GUEST,
})
